import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export default createStyleSheet({
  container: {
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    border: `1px solid ${COLORS.GREY_DARK.DEFAULT}`,
    borderRadius: '8px',
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  button: {
    background: COLORS.WHITE.DEFAULT,
    cursor: 'pointer',
    padding: '8px',
    ...TYPOGRAPHY.BODY3,
  },
  buttonIncrement: {
    borderStartEndRadius: '8px',
    borderEndEndRadius: '8px',
    borderLeft: `1px solid ${COLORS.GREY_DARK.DEFAULT}`,
  },
  buttonDecrement: {
    borderStartStartRadius: '8px',
    borderEndStartRadius: '8px',
    borderRight: `1px solid ${COLORS.GREY_DARK.DEFAULT}`,
  },
  time: {
    padding: '0 32px',
    ...TYPOGRAPHY.BODY3,
  },
});
